var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoArrowLeftDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 6,
    viewBox: "0 0 4 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.207 3 2.647 2.268a.387.387 0 0 1 0 .606.56.56 0 0 1-.708 0l-3-2.571a.387.387 0 0 1 0-.606l3-2.571a.56.56 0 0 1 .708 0 .387.387 0 0 1 0 .606L1.207 3z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "rkfel6fq1a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 4,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m1.207 3 2.647 2.268a.387.387 0 0 1 0 .606.56.56 0 0 1-.708 0l-3-2.571a.387.387 0 0 1 0-.606l3-2.571a.56.56 0 0 1 .708 0 .387.387 0 0 1 0 .606L1.207 3z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowLeftDark);
export default __webpack_public_path__ + "static/media/ico-arrow-left-dark.f5f3a73a29625085e6a6a1e4cc5a990c.svg";
export { ForwardRef as ReactComponent };